import React from "react";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { ViewModule as CardViewIcon, ViewList as TableViewIcon } from "@mui/icons-material";

interface ViewToggleProps {
    view: "card" | "table";
    onChange: (view: "card" | "table") => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ view, onChange }) => {
    const handleChange = (_event: React.MouseEvent<HTMLElement>, newView: "card" | "table" | null) => {
        if (newView !== null) {
            onChange(newView);
        }
    };

    return (
        <ToggleButtonGroup
            value={view}
            exclusive
            onChange={handleChange}
            aria-label="view toggle"
            size="small"
            sx={{
                backgroundColor: "white",
                "& .MuiToggleButton-root": {
                    border: "1px solid #E5E7EB",
                    color: "#6B7280",
                    "&.Mui-selected": {
                        backgroundColor: "#3A80F4",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "#2563EB",
                        },
                    },
                    "&:hover": {
                        backgroundColor: "#F3F4F6",
                    },
                },
            }}
        >
            <ToggleButton value="card" aria-label="card view">
                <Tooltip title="Card View" placement="top">
                    <CardViewIcon fontSize="small" />
                </Tooltip>
            </ToggleButton>
            <ToggleButton value="table" aria-label="table view">
                <Tooltip title="Table View" placement="top">
                    <TableViewIcon fontSize="small" />
                </Tooltip>
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

